import { func, node, object, string } from "prop-types";

import FnrButtonWrapperRelay from "UI/FnrButtonWrapperRelay";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrTooltip from "UI/FnrTooltip2/FnrTooltip";

/**
 * @component
 * @param {object} param0
 * @param {string} param0.icon - fowarded to FnrIcon
 * @param {string} param0.tooltipText - enables tooltip funcitonality
 * @param {object} param0.style
 */
const FnrIconWithTooltip = ({
  icon,
  "aria-label": ariaLabel,
  tooltipText,
  style,
  maxWidth,
  onClick,
  ...rest
}) => {
  if (tooltipText) {
    return (
      <FnrTooltip
        data-cy="IconWithTooltip_Tooltip"
        content={tooltipText}
        style={style}
        maxWidth={maxWidth}
        aria-label={ariaLabel}
        wrapInButton
        onClick={onClick}
      >
        <FnrIcon icon={icon} {...rest} />
      </FnrTooltip>
    );
  }

  return (
    <FnrButtonWrapperRelay onClick={onClick}>
      <FnrIcon icon={icon} {...rest} />
    </FnrButtonWrapperRelay>
  );
};

FnrIconWithTooltip.propTypes = {
  icon: string,
  "aria-label": string,
  tooltipText: node,
  style: object,
  maxWidth: string,
  onClick: func,
};

export default FnrIconWithTooltip;
